// extracted by mini-css-extract-plugin
export var actionText = "_hw-4";
export var container = "_hw-0";
export var leftSection = "_hw-1";
export var rightSection = "_hw-2";
export var settingsButton = "_hw-6";
export var settingsIcon = "_hw-7";
export var shortcut = "_hw-5";
export var shortcutGroup = "_hw-3";